"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackerReady = exports.initialize = void 0;
var browser_plugin_link_click_tracking_1 = require("@snowplow/browser-plugin-link-click-tracking");
var snowplow = __importStar(require("@snowplow/browser-tracker"));
var react_ga_1 = __importDefault(require("react-ga"));
var react_gtm_module_with_nonce_1 = __importDefault(require("react-gtm-module-with-nonce"));
var FEATHER_COOKIE_DOMAIN = 'feather-insurance.com';
var initialize = function (props) {
    var _a, _b, _c;
    if (props.snowplow) {
        snowplow.newTracker('sp1', props.snowplow.collector, {
            appId: props.snowplow.appId,
            cookieDomain: FEATHER_COOKIE_DOMAIN,
            cookieSameSite: 'Lax',
            plugins: [(0, browser_plugin_link_click_tracking_1.LinkClickTrackingPlugin)()],
        });
        snowplow.enableActivityTracking({
            minimumVisitLength: 30,
            heartbeatDelay: 10,
        });
        (0, browser_plugin_link_click_tracking_1.enableLinkClickTracking)();
    }
    if (props.googleAnalytics) {
        react_ga_1.default.initialize(props.googleAnalytics.trackingCode, {
            debug: false,
            gaOptions: { allowLinker: true },
        });
        react_ga_1.default.set({ anonymizeIp: true });
        react_ga_1.default.ga('linker:autoLink', [FEATHER_COOKIE_DOMAIN]);
    }
    if (props.googleTagManager) {
        react_gtm_module_with_nonce_1.default.initialize({
            gtmId: props.googleTagManager.containerId,
            nonce: (_a = props.googleTagManager) === null || _a === void 0 ? void 0 : _a.nonce,
            auth: (_b = props.googleTagManager) === null || _b === void 0 ? void 0 : _b.auth,
            preview: (_c = props.googleTagManager) === null || _c === void 0 ? void 0 : _c.preview,
        });
    }
};
exports.initialize = initialize;
/**
 * React-ga uses the window.ga object to check if Google Analytics has initialized correctly.
 * There are some situations when Google Analytics will not initialize,
 * for example, before the user accepts cookies or if the user declined certain cookies.
 *
 * This function checks if the window.ga object is available
 * to prevent sending events when Google Analytics is not initialized.
 *
 */
var trackerReady = function () { return window && Boolean(window.ga); };
exports.trackerReady = trackerReady;
